<template>
  <div type="text"
       style="min-width: 400px;font-weight: 500;padding: 12px 0;">
      <div>
          <span v-if="product == 'sociales'">
          </span>
          <span v-if="product !== 'comment' && product !== 'sociales'">
            {{ computePlats(data[0].plat) }}:
            <span v-for="_item in data"
                  :key="_item.cid">
                {{ _item.cat_name.join('>') }}&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
          <span v-if="product == 'comment'">
            <span v-for="_item in data"
                  :key="_item.cid">
                {{ computePlats(_item.plat) }}:
                {{ _item.cat_name.join('>') }}&nbsp;&nbsp;&nbsp;&nbsp;
            </span>
          </span>
      </div>
  </div>
</template>

<script>
export default {
  props: ['value', 'field', 'xprops'],
  data() {
    return {}
  },
  computed: {
    data() {
      return this.value
    },
    product() {
      return this.$attrs.row.product
    }
  },
  methods: {
    computePlats(plats) {
      if (plats) {
        return plats
          .split(',')
          .map((item) => this.computePlat(item))
          .join()
      }
    },
    computePlat(plat) {
      let platMap = {
        'jd': '京东',
        'all': '淘宝',
        'cshop': '淘宝',
        'tmall': '天猫',
        'douyin': '抖音',
        'amazon_us': this.$t('inspiration.amazon_us'),
        'amazon_de': this.$t('inspiration.amazon_de'),
        'amazon_es': this.$t('inspiration.amazon_es'),
        'amazon_fr': this.$t('inspiration.amazon_fr'),
        'amazon_it': this.$t('inspiration.amazon_it'),
        'amazon_uk': this.$t('inspiration.amazon_uk'),
        'amazon_jp': this.$t('inspiration.amazon_jp') ,
        'shopee_vn': this.$t('inspiration.shopee_vn'),
        'shopee_th': this.$t('inspiration.shopee_th'),
        'shopee_sg': this.$t('inspiration.shopee_sg'),
        'shopee_my': this.$t('inspiration.shopee_my'),
        'shopee_ph': this.$t('inspiration.shopee_ph'),
        'shopee_id': this.$t('inspiration.shopee_id'),
        'shopee_tw': this.$t('inspiration.shopee_tw') ,
        'lazada_vn': this.$t('inspiration.lazada_vn'),
        'lazada_th': this.$t('inspiration.lazada_th'),
        'lazada_sg': this.$t('inspiration.lazada_sg'),
        'lazada_my': this.$t('inspiration.lazada_my'),
        'lazada_ph': this.$t('inspiration.lazada_ph'),
        'lazada_id': this.$t('inspiration.lazada_id'),
      }
      return platMap[plat]
    },
  },
}
</script>

<style lang="less" scoped>
</style>